import { render, staticRenderFns } from "./pageNav.vue?vue&type=template&id=dd3ca610&scoped=true"
import script from "./pageNav.vue?vue&type=script&lang=js"
export * from "./pageNav.vue?vue&type=script&lang=js"
import style0 from "./pageNav.vue?vue&type=style&index=0&id=dd3ca610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3ca610",
  null
  
)

export default component.exports